/**
 * Countries the citizen sign-in phone picker offers.
 *
 * mvp-v1 §15 (FINAL): the v1 pilot supports **Canada (+1) ONLY**. Keep
 * the picker in sync with the Twilio Geographic Permissions AND mirror
 * any change in admin/src/lib/supported-countries.ts AND
 * mobile/lib/widgets/phone_email_field.dart.
 *
 * Dev escape hatch: setting `VITE_DEV_EXTRA_COUNTRIES=true` (staging /
 * local builds only — never production) re-adds Iran so the founding
 * team can sign in with local numbers. The api's non-prod debugCode
 * bypass handles delivery for those numbers.
 */
import type { CountryIso2 } from 'react-international-phone';

const DEV_EXTRA_COUNTRIES: CountryIso2[] =
  import.meta.env.VITE_DEV_EXTRA_COUNTRIES === 'true' ? ['ir'] : [];

export const SMS_COUNTRIES: CountryIso2[] = [
  // v1 pilot — Canada only (mvp-v1 §15)
  'ca',
  // Team-testing extras, gated behind VITE_DEV_EXTRA_COUNTRIES
  ...DEV_EXTRA_COUNTRIES,
];
export const DEFAULT_COUNTRY: CountryIso2 = 'ca';

/**
 * Whether to surface the Email-OTP option in the sign-in UI. Temporarily
 * `false` while SendGrid's DNS authentication propagates — showing a
 * tab whose Continue button mock-logs but never delivers would confuse
 * users. Flip to `true` once `EMAIL_PROVIDER=sendgrid` lands on the api.
 */
export const EMAIL_OTP_ENABLED = false;
